import React from "react"
import DropdownSpan from "../DropdownSpan"
import { renderToggleIcon } from "../utils"

type SelectInputProps = {
	icon?: React.ReactNode
	disabled?: boolean
	size?: "small" | "medium" | "large"
	children?: React.ReactNode
	isOpen?: boolean
	onClickChevron?: () => void
}

const InputSelect = (props: SelectInputProps) => {
	const {
		disabled = false,
		icon,
		isOpen = true,
		size = "medium",
		children,
		onClickChevron = () => undefined,
	} = props

	return (
		<>
			{icon && (
				<DropdownSpan title="icon" disabled={disabled}>
					{icon}
				</DropdownSpan>
			)}
			{children}
			<DropdownSpan onClick={onClickChevron} title="toggle" disabled={disabled}>
				{renderToggleIcon(isOpen, size)}
			</DropdownSpan>
		</>
	)
}

export default InputSelect
